import { Skeleton } from "antd";

import { getTurnoverInsights } from "api/services/dashboard";
import { EarlyAttritionChart, HiresLeaversChart, ReasonBars, TurnoverRateChart } from "./workforce/charts";
import CostCenterTurnoverTable from "./workforce/CostCenterTurnoverTable";
import { TurnoverKpis } from "./workforce/KpiTiles";
import { UpcomingSection } from "./workforce/PeopleLists";
import StatCard, { Section } from "./workforce/StatCard";
import { useStatsData } from "./workforce/useStatsData";

const periodLabel = (data) => {
  if (data?.all_time) return "all time";
  if (data?.window_months === 1) return "this month to date";
  return `last ${data?.window_months} months`;
};

/** Employee Statistics > Turnover & retention tab: who is leaving, from
 *  where and why, and what HR has to act on in the next 30 days. */
const TurnoverTab = ({ filters }) => {
  const { loading, error, data } = useStatsData(getTurnoverInsights, filters, { withPeriod: true });
  // Every window ends with the current month, so "1 month" is this month so far.
  const period = periodLabel(data);
  if (error) return <div className="alert alert-danger" role="alert">{error}</div>;
  if (!data) return <Skeleton active paragraph={{ rows: 12 }} />;
  return (
    <div className={`ws-content ${loading ? "is-loading" : ""}`} aria-busy={loading}>
      <TurnoverKpis summary={data.summary} period={period} />
      <Section title="Coming up">
        <UpcomingSection upcoming={data.upcoming} />
      </Section>
      <Section title="Movement">
        <div className="ws-grid ws-grid--2">
          <StatCard title="Hires and leavers" hint={`Per month, ${period}; the current month is to date`}>
            <HiresLeaversChart trend={data.turnover_trend} />
          </StatCard>
          <StatCard title="Monthly turnover rate" hint="Leavers ÷ average headcount that month">
            <TurnoverRateChart trend={data.turnover_trend} />
          </StatCard>
        </div>
      </Section>
      <Section title="Why and when people leave">
        <div className="ws-grid ws-grid--2">
          <StatCard title="Why people left" hint="BC termination reason code, selected period">
            <ReasonBars reasons={data.leaver_reasons} />
          </StatCard>
          <StatCard title="How long leavers had been with us" hint="Time in job at exit, by reason">
            <EarlyAttritionChart bands={data.early_attrition} />
          </StatCard>
        </div>
      </Section>
      <Section title="By cost center">
        <StatCard title="Turnover by cost center" hint="Annualised, highest first. Click a column to re-sort.">
          <CostCenterTurnoverTable rows={data.by_cost_center} />
        </StatCard>
      </Section>
    </div>
  );
};

export default TurnoverTab;
